import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

import Button from 'components/virtual/buttons/Button'
import { ReactComponent as Logo } from 'images/logos/logo-and-text.svg'

const useStyles = makeStyles({
  navbar: {
    alignItems: 'center',
    display: 'flex',
    height: 96,
    justifyContent: 'space-between',
    margin: 'auto',
    maxWidth: 1440,
    width: '100%',
  },
})

function Navbar({ hideButton, label, onClick }) {
  const classes = useStyles()

  return (
    <div className={classes.navbar}>
      <Logo />
      {!hideButton && (
        <Button color="primary" label={label} onClick={onClick} size="medium" type="outlined" />
      )}
    </div>
  )
}

Navbar.propTypes = {
  hideButton: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

Navbar.defaultProps = {
  hideButton: false,
  onClick: () => {},
}

export default Navbar
